module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// E:/Projects/HaMafteach/HaMafteach Comprehensive/online-database/web-client/src/app/core/containers/app/app.html
// module id = ../../../../../src/app/core/containers/app/app.html
// module chunks = main